export const locale = {
  lang: 'es',
  data: {
    MENU: {
      CENTER: 'Centro',
      SAMPLE: 'Ejemplo',
      DASHBOARD: 'Dashboard',
      DEVICES: 'Dispositivos',
      REPORTS: 'Reportes',
      SEARCH_DOWNLOAD: 'Búsqueda/Descarga',
      COMPANY: 'Compañía',
      COMPANIES: 'Compañías',
      WORKERS: 'Trabajadores',
      FULLNAME: 'Nombre completo',
      NAMEPARAMETER: 'Parámetro del nombre',
      SEARCH: 'Búsqueda',
      NEW: 'Nuevo registro',
      LIST: 'Listado',
      INFORMATION: 'Información'
    }
  }
};
